/* eslint-disable jsx-a11y/anchor-is-valid */
import {useFormik} from 'formik'
import {Modal} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useRef, useState} from 'react'
//constants

//style
import './Registration.scss'
import OTPInput from 'react-otp-input'
import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

import {logout, sendMobileOtp} from './UserLoginRedux/UserLoginSlice'
import {reset} from '../../../../Redux/store'

interface modalTypes {
  show: boolean
  handleClose: any
  email: string
  phoneNumber: string
  stopLoading: any
}

const RegistrationOtpModal = ({
  show,
  handleClose,
  email,
  phoneNumber,
  stopLoading,
  handleEnter,
  OTP,
  setOTP,
  otpType,
}: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const ResendMobileOtp = (e: any) => {
    e.preventDefault()
    let data = {
      email: email,
    }
    dispatch(sendMobileOtp(data))
  }

  useEffect(() => {
    dispatch(sendMobileOtp({email: email}))
  }, [email])
  const handleClick = () => {
    handleClose()
    dispatch(reset())
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-500px h-auto'
        show={show}
        onHide={handleClose}
        backdrop='static'
      >
        <div>
          <div className='modal-header'>
            <h2> Verification Required</h2>
            <div className='btn btn-icon btn-sm' onClick={handleClick}>
              <span>
                <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
              </span>
            </div>
          </div>
          <div className='modal-body'>
            <div className='row fw-bold d-flex justify-content-center mb-4'>
              We've sent a 6-digit verification code to: {' '}
              {otpType === 'SIGNIN_EMAIL'
                ? `${email?.replace(/^.{5}/, '.'.repeat(5))}`
                : `+61 xxxxxxxxx${phoneNumber?.slice(-3)}`}
              {' '}. Please enter the code below to verify your account.
            </div>
            <div className='row otp-field'>
              <OTPInput
                value={OTP}
                onChange={(code: number) => setOTP(code)}
                numInputs={6}
                separator={<span style={{width: '8px'}}></span>}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle={{
                  border: '1px solid transparent',
                  borderRadius: '8px',
                  width: '54px',
                  height: '54px',
                  fontSize: '12px',
                  color: '#000',
                  fontWeight: '400',
                  caretColor: 'blue',
                }}
              />
              <div className='d-flex justify-content-center'>
                <button className='otpVerify' onClick={handleEnter}>
                  Verify
                </button>
              </div>
            </div>
            <span className='d-flex justify-content-center mt-3'>
              Didn’t receive/expired code?{' '}
              <span
                className='ms-1 text-primary link-hover'
                onClick={ResendMobileOtp}
              >
                Resend code
              </span>
            </span>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(RegistrationOtpModal)
